import { Menu } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { DotsVerticalIcon } from "@modulz/radix-icons";
import styled from "styled-components";

const CellWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

export const RequestActionsCell = ({
	data,
}: { data: Request }): JSX.Element => {

  const navigate = useNavigate();
	return (
		<CellWrapper>
			<Menu
				style={{
					color: "var(--textColor)",
					backgroundColor: "var(--accentBg)",
					border: "var(--accentBg)",
				}}
				shadow="md"
				control={
					<div>
						<DotsVerticalIcon />
					</div>
				}
			>
				<Menu.Label>Request Actions</Menu.Label>
				<Menu.Item
					style={{
						color: "var(--textColor)",
						backgroundColor: "var(--accentBg)",
						border: "var(--accentBg)",
					}}
					onClick={() => navigate(`/requests/${data.id}`)}
				>
					View Details
				</Menu.Item>
			</Menu>
		</CellWrapper>
	);
};
